// @flow
import { useEffect } from 'react';
/**
 * Doesn't outline elements with tabIndex when clicking
 * But outlines when the keyboard is used.
 * More: https://stackoverflow.com/a/51093815/8936345
 */

export var useMouseDetector = function useMouseDetector()
/*: void */
{
  useEffect(function () {
    // Let the document know when the mouse is being used
    // eslint-disable-next-line no-unused-expressions
    document.body
    /* Flow... */
    && document.body.addEventListener('mousedown', function () {
      // eslint-disable-next-line no-unused-expressions
      document.body && document.body.classList.add('using-mouse');
    }); // Re-enable focus styling when Tab is pressed
    // eslint-disable-next-line no-unused-expressions

    document.body && document.body.addEventListener('keydown', function (event
    /*: KeyboardEvent */
    ) {
      if (event.keyCode === 9) {
        if (document && document.body) {
          document.body.classList.remove('using-mouse');
        }
      }
    });
    return function () {
      // Let the document know when the mouse is being used
      // eslint-disable-next-line no-unused-expressions
      document.body && document.body.removeEventListener('mousedown', function () {
        // eslint-disable-next-line no-unused-expressions
        document.body && document.body.classList.add('using-mouse');
      }); // Re-enable focus styling when Tab is pressed
      // eslint-disable-next-line no-unused-expressions

      document.body && document.body.removeEventListener('keydown', function (event
      /*: KeyboardEvent */
      ) {
        if (event.keyCode === 9) {
          // eslint-disable-next-line no-unused-expressions
          document.body && document.body.classList.remove('using-mouse');
        }
      });
    };
  }, []);
};